export const paginateElements = (elements: Array<any>, page: number, limit: number) => {
  const results = [ ...elements ].splice((page - 1) * limit, limit);
  return results;
};



// WEBPACK FOOTER //
// ./src/helpers/paginateElements.ts